module.exports = __webpack_public_path__ + "f4039a9dc129282c8e044d643d51af97.png";